import type { YscApiClient } from '@yescapa-dev/ysc-api-js/legacy'

export const useYscApi = (): { $api: YscApiClient } => {
  const { $api } = useNuxtApp()

  return { $api }
}
